/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./$.to-object');

require('./$.object-sap')('getPrototypeOf', function($getPrototypeOf){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/es6.object.get-prototype-of.js
 ** module id = 1347
 ** module chunks = 0
 **/